export const frAudiences = {
    'audience.filter.label': 'Audience',

    // AUDIENCES
    'audiences.filters.audience.favorite': 'Audience : Centres favoris', //TODO: delete
    'audiences.filters.audience.all': 'Audience : Tous',
    'audiences.filters.audience.audience': 'Audience :',
    'audiences.filters.audience.audience.shops': 'Audience : {count} centres',
    'audiences.filters.audience.audience.shop': 'Audience : {name}',
    'audiences.filters.audience.empty':
        'Vous n’avez pas les droits nécessaires pour filtrer l’audience',
};
